import { useLang } from "../context/LanguageContext";
import { FadeUp } from "./Reveal";

const CHAPTER_IMAGES = [
  "https://images.pexels.com/photos/14909610/pexels-photo-14909610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/34025114/pexels-photo-34025114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1750210505997-ed85e9f8cb12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxtZXJjZWRlcyUyMHYlMjBjbGFzcyUyMGJsYWNrJTIwdmlwJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg0ODM0NTEwfDA&ixlib=rb-4.1.0&q=85",
];

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="why" className="relative py-24 md:py-40 bg-[#050505]" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp>
          <p className="font-mono text-xs tracking-[0.3em] text-[#d4af37] mb-6">{t.manifesto.overline}</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-2xl leading-tight">
            {t.manifesto.title}
          </h2>
        </FadeUp>

        <div className="mt-20 md:mt-28 flex flex-col gap-24 md:gap-40">
          {t.manifesto.chapters.map((ch, i) => (
            <div
              key={ch.num}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center"
              data-testid={`manifesto-chapter-${ch.num}`}
            >
              {/* Number + text */}
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <FadeUp>
                  <span className="font-mono text-sm text-white/30 block mb-4">CH. {ch.num}</span>
                  <div className="flex items-start gap-6">
                    <span className="font-serif text-7xl md:text-8xl text-[#d4af37]/80 leading-none">
                      {ch.num}
                    </span>
                    <div className="pt-2">
                      <h3 className="font-serif text-3xl md:text-4xl text-white mb-4">{ch.title}</h3>
                      <p className="font-sans text-base md:text-lg text-white/60 leading-relaxed max-w-md">
                        {ch.text}
                      </p>
                    </div>
                  </div>
                </FadeUp>
              </div>

              {/* Spotlight image */}
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <FadeUp delay={0.15}>
                  <div className="img-zoom-parent relative overflow-hidden aspect-[4/5] md:aspect-[3/4] border border-white/10">
                    <img
                      src={CHAPTER_IMAGES[i]}
                      alt={ch.title}
                      className="img-zoom w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </FadeUp>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
